export default "__VITE_ASSET__DGG8akAf__"